<h1 mat-dialog-title class="text-dark text-xl">Nuova Comunicazione</h1>
<div mat-dialog-content class="w-full">
  <app-communication-practice-form [data]="data"></app-communication-practice-form>
</div>
